import { QueryClient } from 'react-query';
import api from './index';

const request = (method, url, { headers, ...params }) =>
  api.request({
    method,
    url,
    params,
    headers,
  });

export const defaultQueryFn = async ({ queryKey }) => {
  if (queryKey[1] && (queryKey[1].includes('undefined') || queryKey[1].includes('null'))) {
    return null;
  }
  const { data } = await request(queryKey[0], queryKey[1], queryKey[2]);
  return data;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 5,
      staleTime: 1000 * 60 * 5,
      refetchOnMount: false,
      queryFn: defaultQueryFn,
    },
  },
});

export default queryClient;
